import "core-js/modules/es.array.push.js";
import request from "../../util/request";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Scene',
  data() {
    /* let validateQuestion_Name = (rule, value, callback) => {
       if (value === this.repeatName && this.dialogFormVisibleEdit === true) {
         callback()
       } else {
         request.get('/Scene/getByName', {
           params: {
             sceneName: value,
           }
         }).then(res => {
           if (res == null || res == '') {
             callback()
           } else {
             callback(new Error("名称重复，重新输入！"))
           }
         });
       }
       };*/
    return {
      maxtermId: this.$route.query.maxtermId,
      search: '',
      repeatName: '',
      //判断名字是否重复
      form: {
        sceneStandard: 0
      },
      editform: {},
      dialogFormVisibleEdit: false,
      dialogFormVisible: false,
      currentPage: 1,
      pageSize: 20,
      total: 10,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket: [],
      //未分页的数据
      tableData: [],
      reload: 0,
      //判断重新将currentPage 设置为 1； 0：currentPage=1
      varValue: "",
      //判断是否已经点击了模糊查询
      rules: {
        // sceneName: [
        //   // { pattern:/^([a-z0-9]([a-z0-9-.]*)[a-z0-9])$|^([a-z0-9])$/, message: '只能输入小写字母、数字、点号.和横线-并且点号 . 和横线 - 不能在开头或结尾', trigger: 'blur' },
        //   {required: true, min: 2, max: 50, message: '模板细项名不能为空,长度： 2 ~ 50', trigger: 'blur'},
        //   {validator: validateQuestion_Name, required: true, message: '模板细项名重复，重新输入', trigger: 'blur'}
        // ],
        createBy: [{
          required: true,
          message: '请输入创建人',
          trigger: 'blur'
        }],
        createDate: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }]
      }
    };
  },
  created() {
    this.load();
  },
  methods: {
    qSearch() {
      if (this.search == null || this.search == "") {
        this.load();
      }
      request.get('/Scene/getByName', {
        params: {
          sceneName: this.search
        }
      }).then(res => {
        console.log(res);
        this.tableData = res;
        this.total = this.tableData.length;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    //添加按钮点击事件
    add() {
      this.dialogFormVisible = true;
    },
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return "";
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    //页面初始化
    load() {
      request.post('/Scene/SceneAll', this.maxtermId).then(res => {
        console.log(res);
        this.ticket = res;
        this.total = this.ticket.length;
        this.getPageInfo();
      });
    },
    //保持数据
    save(formName) {
      console.log(this.$refs[formName]);
      this.$refs[formName].validate(valid => {
        //valid是检验的结果,bool值 validator: validateSolution_Name,
        console.log("看看");
        if (valid) {
          this.form.createBy = sessionStorage.getItem('userName');
          this.form.createDate = new Date();
          this.form.maxtermId = this.maxtermId;
          request.post('/Scene/save', this.form).then(res => {
            console.log(res.code + res.mag + res.date + "save" + res);
            if (res == 1) {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.load();
              this.dialogFormVisible = false;
              this.form = {};
              this.form.sceneStandard = 0;
            } else {
              this.$message({
                message: "添加失败",
                type: "error"
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //修改数据
    edit(formName) {
      //console.log(this.editform.solution_Lock+"--"+this.editform.solution_StatType+"--"+this.editform.solution_Type)
      this.$refs[formName].validate(valid => {
        //valid是检验的结果,bool值
        if (valid) {
          this.editform.updateBy = sessionStorage.getItem('userName');
          this.editform.updateDate = new Date();
          this.editform.sceneName = this.editform.sceneName.replace(/\s*/g, '');
          request.post('/Scene/update', this.editform).then(res => {
            if (res == 1) {
              this.$message({
                message: "编辑成功",
                type: "success"
              });
              this.load();
              this.dialogFormVisibleEdit = false;
            } else {
              this.$message({
                message: "编辑失败",
                type: "error"
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //跳转到模板大项页面
    toMaxterm(maxtermId) {
      this.$router.push({
        path: 'Scene',
        query: {
          maxtermId: maxtermId
        }
      });
    },
    //修改按钮点击事件
    update(row) {
      this.dialogFormVisibleEdit = true;
      this.editform = JSON.parse(JSON.stringify(row));
      this.repeatName = JSON.parse(JSON.stringify(row.sceneName));
    },
    //修改按钮点击事件
    deleteOne(sceneId) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.post('/Scene/delete', sceneId).then(res => {
          if (res > 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: '删除失败'
            });
          }
          this.load();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //分页三件套
    // 获取当前页的数据信息
    getPageInfo() {
      //清空pageTicket中的数据
      this.tableData = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tableData.length === this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.getPageInfo();
    },
    tableRowClassName({
      rowIndex
    }) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }
      }
      return '';
    }
  }
};